import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { useFreecodeContext } from 'hooks/useContext';
import ConfirmModal from 'components/Modals/confirmModal';
import { RectangleButton } from 'components/Button/rectangleButton';

export default function ResetImplementation() {
  const { testImpl } = useFreecodeContext();

  const [resetting, setResetting] = useState(false);
  const [viewModal, setViewModal] = useState(false);

  const resetImplementation = () => {
    setResetting(true);
    // TODO reset implementation here...
    setTimeout(() => setResetting(false), 1000);
    console.log('should reset testImpl', testImpl._id);
    toast.error('Resetting Challenge Implementation Not Implemented!');
  };

  return (
    <RectangleButton small floatRight onClick={() => setViewModal(true)}>
      Reset Implementation
      {viewModal && (
        <ConfirmModal
          title="Reset Implementation"
          text="When resetting the implementation all of your custom code will be lost. Do you want to continue?"
          onCancel={() => !resetting && setViewModal(false)}
          onConfirm={resetImplementation}
          loading={resetting}
        />
      )}
    </RectangleButton>
  );
}
